import React from 'react';
import { Outlet } from 'react-router-dom';
import Topbar from './Topbar';
import ChatWidget from './ChatWidget';

export default function Layout() {
  return (
    <div style={{ display: 'flex', flexDirection: 'column', minHeight: '100vh', background: 'var(--bg-base)' }}>
      <Topbar />
      <main style={{ flex: 1, padding: 28, overflow: 'auto' }}>
        <Outlet />
      </main>
      <ChatWidget />
    </div>
  );
}
